<template>
  <div class="health-title">
    <div class="health-3 oth-health">
      <div class="health-4-1 border-left border-right">
        <div class="border-right">身高</div>
        <div>
          <el-input
            @blur="wHealth"
            v-model="addForm.height"
            :disabled="setTitle === '查看'"
            placeholder="请输入"
          >
            <i slot="suffix">cm</i>
          </el-input>
        </div>
      </div>
      <div class="health-4-1 border-right">
        <div class="border-right">体重</div>
        <div>
          <el-input
            @blur="wHealth"
            v-model="addForm.weight"
            :disabled="setTitle === '查看'"
            placeholder="请输入"
          >
            <i slot="suffix">kg</i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="health-1 border-bottom border-top border-left border-right">
      <div class="border-right">病史</div>
      <div>
        <el-checkbox-group
          @change="changeDisease"
          v-model="diseaseId"
          :disabled="setTitle === '查看'"
        >
          <el-checkbox label="健康">健康</el-checkbox>
          <el-checkbox label="高血压">高血压</el-checkbox>
          <el-checkbox label="脑卒中">脑卒中</el-checkbox>
          <el-checkbox label="冠心病">冠心病</el-checkbox>
          <el-checkbox label="糖尿病">糖尿病</el-checkbox>
          <el-checkbox label="类风湿">类风湿</el-checkbox>
          <el-checkbox label="脑出血">脑出血</el-checkbox>
          <el-checkbox label="高血脂">高血脂</el-checkbox>
          <el-checkbox label="系统性班狼疮">系统性班狼疮</el-checkbox>
          <el-checkbox label="恶性肿瘤">恶性肿瘤</el-checkbox>
          <el-checkbox label="精神疾病">精神疾病</el-checkbox>
          <el-checkbox label="结核病">结核病</el-checkbox>
          <el-checkbox label="肝炎">肝炎</el-checkbox>
          <el-checkbox label="其他法定传染病">其他法定传染病 </el-checkbox>
          <el-checkbox label="慢性阻塞性肺疾病">慢性阻塞性肺疾病 </el-checkbox>
          <el-checkbox label="慢性支气管炎">慢性支气管炎</el-checkbox>
          <el-checkbox label="帕金森综合症">帕金森综合症</el-checkbox>
          <el-checkbox label="腰椎间盘突出">腰椎间盘突出</el-checkbox>
          <el-checkbox label="阿尔茨海默病">阿尔茨海默病</el-checkbox>
          <el-checkbox label="其他">其他</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
      <div class="border-right">自理类别</div>
      <div>
        <el-radio-group
          v-model="addForm.selfCareType"
          :disabled="setTitle === '查看'"
        >
          <el-radio @click.native.prevent="onRadioChange(0)" :label="0"
            >自理
          </el-radio>
          <el-radio @click.native.prevent="onRadioChange(1)" :label="1"
            >失能
          </el-radio>
          <el-radio :label="2" @click.native.prevent="onRadioChange(2)"
            >半失能
          </el-radio>
          <el-radio :label="3" @click.native.prevent="onRadioChange(3)"
            >失智
          </el-radio>
          <el-radio :label="4" @click.native.prevent="onRadioChange(4)"
            >轻度依赖
          </el-radio>
          <el-radio :label="5" @click.native.prevent="onRadioChange(5)"
            >重度依赖
          </el-radio>
          <el-radio :label="6" @click.native.prevent="onRadioChange(6)"
            >不能自理
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">视力残疾</div>
        <div>
            <el-radio-group
                @blur="wHealth"
                v-model="addForm.visualAbility"
                :disabled="setTitle === '查看'"
                @change="visualChange"
            >
                <el-radio :label="0">一级盲</el-radio>
                <el-radio :label="1">二级盲</el-radio>
                <el-radio :label="2">一级低视力</el-radio>
                <el-radio :label="3">二级低视力</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">听力残疾</div>
        <div>
            <el-radio-group
                @blur="wHealth"
                v-model="addForm.hearAbility"
                @change="hearChange"
                :disabled="setTitle === '查看'"
            >
                <el-radio :label="0">一级听力残疾</el-radio>
                <el-radio :label="1">二级听力残疾</el-radio>
                <el-radio :label="2">三级听力残疾</el-radio>
                <el-radio :label="3">四级听力残疾</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">言语残疾</div>
        <div>
            <el-radio-group
                @blur="wHealth"
                v-model="addForm.speechAbility"
                @change="speechChange"
                :disabled="setTitle === '查看'"
            >
                <el-radio :label="0">一级言语残疾</el-radio>
                <el-radio :label="1">二级言语残疾</el-radio>
                <el-radio :label="2">三级言语残疾</el-radio>
                <el-radio :label="3">四级言语残疾</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">智力残疾</div>
        <div>
            <el-radio-group
                @blur="wHealth"
                v-model="addForm.intellectualAbility"
                :disabled="setTitle === '查看'"
                @change="intellChange"
            >
                <el-radio :label="0">一级智力残疾（重度）</el-radio>
                <el-radio :label="1">二级智力残疾（重度）</el-radio>
                <el-radio :label="2">三级智力残疾（中度）</el-radio>
                <el-radio :label="3">四级智力残疾（轻度）</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">肢体残疾</div>
        <div>
            <el-radio-group
                @blur="wHealth"
                @change="physicalChange"
                v-model="addForm.physicalAbility"
                :disabled="setTitle === '查看'"
            >
                <el-radio :label="0">一级（重度）肢体残疾</el-radio>
                <el-radio :label="1">二级（中度）肢体残疾</el-radio>
                <el-radio :label="2">三级（轻度）肢体残疾</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">精神残疾</div>
        <div>
            <el-radio-group
                @blur="wHealth"
                v-model="addForm.mentalAbility"
                @change="mentalChange"
                :disabled="setTitle === '查看'"
            >
                <el-radio :label="0">一级（重度）精神残疾</el-radio>
                <el-radio :label="1">二级（中度）精神残疾</el-radio>
                <el-radio :label="2">三级（轻度）精神残疾</el-radio>
            </el-radio-group>
        </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
        <div class="border-right">残疾部位</div>
        <div>
            <el-checkbox-group
                @blur="wHealth"
                v-model="disabledPart"
                :disabled="setTitle === '查看'"
            >
                <el-checkbox label="0">视力残疾</el-checkbox>
                <el-checkbox label="1">听力残疾</el-checkbox>
                <el-checkbox label="2">言语残疾</el-checkbox>
                <el-checkbox label="3">智力残疾</el-checkbox>
                <el-checkbox label="4">肢体残疾</el-checkbox>
                <el-checkbox label="5">精神残疾</el-checkbox>
            </el-checkbox-group>
        </div>
    </div> -->
    <div class="health-2 border-bottom border-left border-right">
      <div class="border-right">残疾证号</div>
      <div>
        <el-input
          @blur="wHealth"
          v-model="addForm.disabilityNo"
          :disabled="setTitle === '查看'"
        ></el-input>
      </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
      <div class="border-right">残疾类型</div>
      <div>
        <el-checkbox-group
          v-model="disabilityType"
          :disabled="setTitle === '查看'"
          @change="disabilityTypeChange"
        >
          <el-checkbox label="1">视力残疾</el-checkbox>
          <el-checkbox label="2">听力残疾</el-checkbox>
          <el-checkbox label="3">言语残疾</el-checkbox>
          <el-checkbox label="4">肢体残疾</el-checkbox>
          <el-checkbox label="5">智力残疾</el-checkbox>
          <el-checkbox label="6">精神残疾</el-checkbox>
          <el-checkbox label="7">多重残疾</el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
      <div class="border-right">残疾等级</div>
      <div>
        <el-radio-group
          @blur="wHealth"
          v-model="addForm.disabilityLevel"
          @change="mentalChange"
          :disabled="setTitle === '查看'"
        >
          <el-radio label="1">一级</el-radio>
          <el-radio label="2">二级</el-radio>
          <el-radio label="3">三级</el-radio>
          <el-radio label="4">四级</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
      <div class="border-right">士官证号</div>
      <div>
        <el-input
          @blur="wHealth"
          v-model="addForm.sergeantNo"
          :disabled="setTitle === '查看'"
        ></el-input>
      </div>
    </div>
    <div class="health-2 border-bottom border-left border-right">
      <div class="border-right">其它证件号</div>
      <div>
        <el-input
          @blur="wHealth"
          v-model="addForm.otherNo"
          :disabled="setTitle === '查看'"
        ></el-input>
      </div>
    </div>
    <div class="health-3 border-bottom">
      <div class="health-3-1 border-left border-right">
        <div class="border-right">经常服用药物</div>
        <div>
          <el-input
            @blur="wHealth"
            v-model="addForm.regularMedicine"
            :disabled="setTitle === '查看'"
          ></el-input>
        </div>
      </div>
      <div class="health-3-1 border-right">
        <div class="border-right">听力情况</div>
        <div>
          <el-radio-group
            @blur="wHealth"
            v-model="addForm.listen"
            :disabled="setTitle === '查看'"
          >
            <el-radio :label="0">良好</el-radio>
            <el-radio :label="1">一般</el-radio>
            <el-radio :label="2">很大声才能听见</el-radio>
            <el-radio :label="3">听不见</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>

    <div class="health-3 border-bottom">
      <div class="health-4-1 border-left border-right">
        <div class="border-right">药物过敏情况</div>
        <div>
          <el-input
            @blur="wHealth"
            v-model="addForm.medicineAllergy"
            placeholder="请输入"
            :disabled="setTitle === '查看'"
          ></el-input>
        </div>
      </div>
      <div class="health-4-1 border-right">
        <div class="border-right">绑定设备(IMEI)</div>
        <div>
          <el-input
            @blur="wHealth"
            v-model="addForm.bindDevice"
            placeholder="请输入"
            :disabled="setTitle === '查看'"
          ></el-input>
          <!-- <el-select @blur="wHealth" placeholder="请选择" :disabled="setTitle === '查看'" v-model="addForm.bindDevice">
              <el-option></el-option>
          </el-select> -->
        </div>
      </div>
    </div>

    <div class="health-5 border-bottom border-right">
      <div class="border-left border-right">备注</div>
      <div>
        <el-input
          @blur="wHealth"
          v-model="addForm.remark"
          placeholder="请输入"
          type="textarea"
          :rows="2"
          :disabled="setTitle === '查看'"
        ></el-input>
      </div>
    </div>

    <div>
      <el-table
        :data="
          tableData.slice(
            (page.pageNo - 1) * page.pageSize,
            page.pageNo * page.pageSize
          )
        "
        border
        style="width: 100%; margin-top: 20px"
        :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
      >
        <el-table-column
          type="index"
          width="70"
          label="序号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单流水号"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

        <el-table-column
          prop="pressureLow"
          label="血压（低压）KPa"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="pressureHigh"
          label="血压（高压）KPa"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="sugarPlasma"
          label="血糖 mmo/l"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="sugarEmpty"
          label="心率 bpm"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        class="pages"
        background
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange"
        :total="page.total"
        :current-page.sync="page.pageNo"
        :page-size="10"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DateLine from "../graph/line.vue"
import exportVue from "@/utils/exportVue"
import request from "@/utils/request.js"

export default {
  props: {
    setTitle: {
      type: String,
      default: "",
    },
    formData: {},
    wHealthData: {},
  },
  components: {
    DateLine,
  },
  data() {
    return {
      imageUrl: "",
      checkList: [],
      addForm: {
        disabilityType: "",
        disabledPart: [],
      },
      data: {},
      diseaseId: [],
      disabilityType: [],
      disabledPart: [],
      tableData: [],
      page: { pageNo: 1, pageSize: 10, total: 0 },
    }
  },
  watch: {
    formData: {
      handler(val) {
        if (this.formData.id) {
          if (val.customerHealth != null) {
            this.addForm = val.customerHealth
            this.data = val
            this.tableData = val.customerHealthList
              ? val.customerHealthList
              : []
            this.page.total = val.customerHealthList
              ? val.customerHealthList.length
              : 0
            if (this.addForm.disease != null) {
              this.diseaseId = this.addForm.disease.split(",")
            } else {
              this.diseaseId = []
            }
            if (this.addForm.disabilityType) {
              this.disabilityType = this.addForm.disabilityType.split(",")
            }
            this.wHealth()
          }
        }
        if (val.hide) {
          // debugger
          this.addForm = {}
          this.diseaseId = []
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // this.handler(val);
    this.addForm = {}
    exportVue.$on("wcustomerData", (data) => {
      this.data = data
    })
    //老人信息带过来的数据
    exportVue.$on("health", (data) => {
      this.addForm = data.customerHealth
    })
  },
  methods: {
    disabilityTypeChange(val) {
      this.addForm.disabilityType = val ? val.join(",") : ""
    },
    onRadioChange(e) {
      if (e == this.addForm.selfCareType) {
        this.addForm.selfCareType = ""
      } else {
        this.addForm.selfCareType = e
        this.$forceUpdate()
      }
      this.wHealth()
    },

    // 分页
    handleCurrentChange(val) {
      this.page.pageNo = val
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    beforeAvatarUpload(file) {},
    changeDisease(val) {
      this.$set(this.addForm, "disease", val.join(","))
      this.wHealth()
    },
    wHealth() {
      this.$emit("healthInfo", this.addForm)
    },
    visualChange(val) {
      if (val != null) {
        this.disabledPart.push("0")
      }
    },
    hearChange(val) {
      if (val != null) {
        this.disabledPart.push("1")
      }
    },
    speechChange(val) {
      if (val != null) {
        this.disabledPart.push("2")
      }
    },
    intellChange(val) {
      if (val != null) {
        this.disabledPart.push("3")
      }
    },
    physicalChange(val) {
      if (val != null) {
        this.disabledPart.push("4")
      }
    },
    mentalChange(val) {
      if (val != null) {
        this.disabledPart.push("5")
      }
    },
    bracelet() {
      this.$http
        .request({
          url: "/jgyl/admin/equipments/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: -1,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.centent) {
            }
          }
        })
    },
  },
}
</script>

<style lang="less" scoped>
.oth-health {
  border-top: 1px solid #c0c4cc;
}

.health-title {
  width: 98%;
  margin-left: 2%;
}

.shangchuang1 {
  width: 128px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  color: #ffffff;
  margin-top: 15px;
  text-align: center;
  background-color: #0000ff;
}

.he-1 {
  width: 100%;
  display: flex;
  padding: 10px 0;
  background-color: #eeeeee;
}

.he-1 > div {
  width: 25%;
}

.he-2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.he-3 {
}

.he-3-1 {
  margin-top: 20px;
  display: flex;
}

.he-3-3 {
  width: 25%;
}

.he-3-2 {
  width: 100%;
  margin-top: 20px;
  display: flex;
}

.he-3-4 {
  width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.he-4-4 {
  width: 25%;
}

.he-4-4 > div {
  margin-left: 30px;
}

.health-1 {
  width: 100%;
  display: flex;
  height: 100px;
  align-items: center;
}

.health-1 > div:first-child {
  width: 100px;
  text-align: center;
  height: 100px;
  line-height: 100px;
  background-color: #eeeeee;
}

.health-1 > div:nth-child(2) {
  margin-left: 10px;
  width: calc(100% - 110px);
}

.border-top {
  border-top: 1px solid #c0c4cc;
}

.border-right {
  border-right: 1px solid #c0c4cc;
}

.border-bottom {
  border-bottom: 1px solid #c0c4cc;
}

.border-left {
  border-left: 1px solid #c0c4cc;
}

.health-2 {
  width: 100%;
  display: flex;
  height: 50px;
  align-items: center;
}

.health-2 > div:first-child {
  width: 100px;
  text-align: center;
  height: 50px;
  line-height: 50px;
  background-color: #eeeeee;
}

.health-2 > div:nth-child(2) {
  margin-left: 10px;
  width: calc(100% - 110px);
}

.health-3 {
  width: 100%;
  display: flex;
}

.health-3-1 {
  width: 50%;
  display: flex;
  height: 80px;
  align-items: center;
}

.health-3-1 > div:first-child {
  width: 100px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  background-color: #eeeeee;
}

.health-3-1 > div:nth-child(2) {
  margin-left: 10px;
  width: calc(100% - 130px);

  /deep/ .el-textarea__inner {
    border: none;
    resize: none;
  }
}

.health-4-1 {
  width: 50%;
  display: flex;
  height: 40px;
  align-items: center;
}

.health-4-1 > div:first-child {
  width: 100px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  background-color: #eeeeee;
}

.health-4-1 > div:nth-child(2) {
  // margin-left: 10px;
  width: calc(100% - 120px);

  /deep/ .el-input__inner {
    border: none;
  }
}

.health-5 {
  width: 100%;
  display: flex;
  height: 80px;
  align-items: center;
}

.health-5 > div:first-child {
  width: 100px;
  text-align: center;
  height: 80px;
  line-height: 80px;
  background-color: #eeeeee;
}

.health-5 > div:nth-child(2) {
  width: calc(100% - 120px);

  /deep/ .el-textarea__inner {
    border: none;
    resize: none;
  }
}

.health-6 {
  width: 90%;
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
}

.health-6 > div {
  width: 24%;
  background-color: #eeeeee;
  height: 100px;
}

.health-6-1 {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}

.health-7 {
  width: 100%;
}

.health-7 > div:first-child {
  width: 100%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  background-color: #55aa7f;
  color: #ffffff;
  border-top: 2px solid #333333;
}

.health-7 > div:nth-child(2) {
  width: 100%;
  background-color: #333;
}

.pages {
  margin-top: 20px;
}
</style>

<style>
.avatar-uploader1 .el-upload {
  border: 1px dashed #bbbbbb;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon1 {
  font-size: 28px;
  color: #8c939d;
  width: 128px;
  height: 128px;
  line-height: 128px;
  text-align: center;
}

.avatar1 {
  width: 128px;
  height: 128px;
  display: block;
}

.el-input__inner {
  border: none;
}
</style>
